import { FETCH_UPDATEPOS_FAILURE, FETCH_UPDATEPOS_REQUEST, FETCH_UPDATEPOS_SUCCESS } from "../actions/types";

const initialState = {
    data: [],
    error: ''
};

export const posUpdatePosReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_UPDATEPOS_REQUEST:
            return {
                ...state,
            }
        case FETCH_UPDATEPOS_SUCCESS:
            return {
                data: action.payload
            }
        case FETCH_UPDATEPOS_FAILURE:
            return {
                data: [],
                error: action.payload
            }
        default:
            return state;
    }
}